export default __webpack_public_path__ + "static/media/login-page-distribution-brazil.8d218413.svg";